import Success from './success'

export default Success
